import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Devis from "./components/Devis/Devis";
import DropdownPanel from "./components/DropdownPanel/DropdownPanel";
import SliderImage from "./components/SliderImage/SliderImage";
import PageTitle from "../../Shared/PageTitle/PageTitle";

import { EquipementData } from "../../../api/EquipementData";

import "./ProductDetails.css";

const ProductDetails = () => {
  // get the specified equipmentId and product Id
  const [selectedProduct, setselectedProduct] = useState({});
  const [selectedEquipment, setselectedEquipment] = useState({});
  const { selectedEquipmentId, productId } = useParams();

  useEffect(() => {
    window.scrollTo(10, 0);
  }, []);

  useEffect(() => {
    // find the selected equipment
    let index = EquipementData.findIndex(
      (eq) => eq.id.toString() === selectedEquipmentId
    );
    if (index === -1) {
      return;
    }

    //find the selected product
    setselectedEquipment(EquipementData[index]);

    const selectedEquipment = EquipementData[index];
    index = selectedEquipment.products.findIndex(
      (pr) => pr.id.toString() === productId
    );
    if (index === -1) {
      return;
    }

    setselectedProduct(selectedEquipment.products[index]);
  }, [productId, selectedEquipmentId, selectedEquipment]);

  return (
    <>
      <PageTitle
        title={"Equipement"}
        currentPage={"Equipement"}
        link={"equipement"}
        category={selectedEquipment.title}
        linkCategory={"single/" + selectedEquipment.id}
        detail={selectedProduct.name}
      />

      <section className="page-content">
        <div className="container">
          <div className="page-content-row">
            <div className="shop-page">
              <div className="row">
                <div className="col-lg-12">
                  <div className="shop-page-details section-padding">
                    <div className="shop-items">
                      <div className="shop-item single">
                        {/* image + description */}
                        <div className="row ">
                          <div className="col-lg-6">
                            <SliderImage data={selectedProduct.images} />
                          </div>
                          <div className="col-lg-6">
                            <div className="shop-info">
                              <h3 className="product-equipment-title">
                                {selectedProduct.name}
                              </h3>

                              <div className="clearfix"></div>

                              <div className="des product-equipment-description">
                                <p>{selectedProduct?.description1}</p>
                                <p>{selectedProduct?.description1}</p>
                              </div>
                              <form>
                                <a
                                  href={selectedProduct.brochure}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn-style22"
                                >
                                  {"Télécharger Brochure"}
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>

                        {/* vid + fiche technique */}
                        <div
                          className="row vid-fiche-technique"
                          style={{ marginTop: "2rem" }}
                        >
                          <div className="col-lg-6">
                            <div className="shop-vid">
                              <iframe
                                className="product-details-vid"
                                src={selectedProduct?.video}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              ></iframe>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            {/* FICHE TECHNIQUE */}

                            <div className="wpo-project-single-content-des-right">
                              <ul className="ul-ficheTechnique">
                                {selectedProduct.ficheTechnique &&
                                  selectedProduct.ficheTechnique.map(
                                    (element) => (
                                      <li key={element.key}>
                                        <p>{element.key}</p>
                                        <span>{element.value}</span>
                                      </li>
                                    )
                                  )}
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <DropdownPanel
                            data={selectedProduct.technicalFeatures}
                          />
                        </div>
                      </div>
                      <div className="tab-area">
                        <Devis selectedProduct={selectedProduct} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
